import LedgerManager from "@/components/admin/LedgerManager";

const COLUMNS = [
  { k: "tanggal", l: "Tanggal", t: "date" },
  { k: "nota", l: "Nota", t: "text" },
  { k: "rincian", l: "Rincian", t: "text" },
  { k: "vol", l: "Vol", t: "text" },
];

export default function LpjMandiriManager() {
  return <LedgerManager kind="mandiri" basePath="/keuangan/lpj-mandiri" title="LPJ Mandiri" columns={COLUMNS} />;
}
